import imageUrl, { commonImgUrl, gdOssUrl } from "@/utils/imageUrl";
import classNames from "classnames";
import Link from "next/link";
import { useMemo } from "react";
import Image from "../Image";
import styles from "./index.module.less";

interface HBAvatarProps {
  user?: any;
  className?: string;
  imgUrl?: string;
  shape?: "square" | "circle";
  size?: number;
  /**作图尺寸，用于提高展示尺寸场景 */
  srcSize?: number;
  withBorder?: boolean;
  withLink?: boolean;
  linkTarget?: string;
}

export default function HBAvatar({
  user,
  shape = "square",
  size = 75,
  srcSize,
  className,
  imgUrl,
  withBorder,
  withLink,
  linkTarget = "_blank",
}: HBAvatarProps) {
  const avatarImgUrl = useMemo<string>(() => {
    if (imgUrl) {
      return commonImgUrl(imgUrl, { width: srcSize || size });
    }

    if (user?.avatar_url) {
      return commonImgUrl(user?.avatar_url, {
        // 最小展示尺寸为75, 减少作图尺寸，增加缓存命中率
        width: Math.max(srcSize || size, 75),
      });
    }

    if (user?.avatar) {
      // 目前头像最小是 75宽度
      return imageUrl(user.avatar, { width: srcSize || size, rect: "sq" });
    } else {
      return gdOssUrl(
        "https://cdn.dancf.com/fe-assets/img/c62d185173c48b4c73f90ea6b7acee33.png"
      );
    }
  }, [imgUrl, user?.avatar, srcSize, size]);

  const avatar = (
    <Image
      className={classNames(
        styles.avatar,
        styles[shape],
        className,
        withBorder && styles.withBorder
      )}
      src={avatarImgUrl}
      alt={user?.username}
      width={size}
      height={size}
    />
  );

  return withLink ? (
    <Link href={`/user/${user?.urlname}`}>
      <a target={linkTarget}>{avatar}</a>
    </Link>
  ) : (
    avatar
  );
}
